import HomeEducation from './HomeEducation';

export default HomeEducation;